import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { IHotelAssociate } from '../../models/hotelAssociateInterfaces';
import { createHotelAssociate, modifyHotelAssociate, statusUpdateHotelAssociate, resetUserPassword } from '../../services/hotelAssociateService';
import { Store } from 'react-notifications-component';
import { APP_NAME, notification_shown_time_success } from '../../config/env';
import { LBL_ASSOCIATE } from '../../config/common_labels'; 
import { MSG_NEW_USER_CREATION_FAILED, MSG_NEW_USER_CREATION, MSG_USER_STATUS_UPDATE, MSG_USER_MODIFICATION, MSG_USER_STATUS_UPDATE_FAILED, MSG_RESET_PASSWORD_EMAIL_SENT, MSG_RESET_PASSWORD_EMAIL_FAILED, MSG_RESET_PASSWORD_USER_NOT_EXISTS } from '../../config/messages';

export interface AddEditState {
  addEditLoading: 'idle' | 'loading' | 'succeeded' | 'error' | 'statusUpdated' | 'statusUpdateFailed';
  error: string | undefined;
}

const initialState: AddEditState = {
addEditLoading: 'idle',
  error: '',
};

export const hotelAssociatesAddEditSlice = createSlice({
  name: 'hotelAssociatesAddEdit',
  initialState,
  reducers: {
    setDataLoading: (state) => {
      state.addEditLoading = 'loading';
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createHotelAssociate.pending, (state) => { 
      state.addEditLoading = 'loading';
    });
    builder.addCase(createHotelAssociate.fulfilled, (state, action) => {
      // const m = action.payload as IHotelAssociate[];
      console.log('createHotelAssociate.fulfilled: ');  
      state.addEditLoading = 'succeeded';
      Store.addNotification({
        title: APP_NAME,
        message: MSG_NEW_USER_CREATION,
        type: 'success',
        insert: 'top',
        container: 'top-center',
        animationIn: ['animate__animated', 'animate__fadeIn'],
        animationOut: ['animate__animated', 'animate__fadeOut'],
        dismiss: {
          duration: notification_shown_time_success,
          onScreen: true,
          pauseOnHover: true,
        },
      });
    });
    builder.addCase(createHotelAssociate.rejected, (state, { payload }: any) => {
      state.addEditLoading = 'error';
      // state.error = action.error.message;
      console.log('payload: ',payload); 
        //   let errStr = MSG_NEW_USER_CREATION_FAILED; 
        //   Store.addNotification({
        //     title: APP_NAME,
        //     message: MSG_NEW_USER_CREATION_FAILED,
        //     type: 'danger',
        //     insert: 'top',
        //     container: 'top-center',
        //     animationIn: ['animate__animated', 'animate__fadeIn'],
        //     animationOut: ['animate__animated', 'animate__fadeOut'],
        //     dismiss: {
        //       duration: notification_shown_time_success,
        //       onScreen: true,
        //       pauseOnHover: true,
        //     },
        //   });
    });


    builder.addCase(modifyHotelAssociate.pending, (state) => { 
        state.addEditLoading = 'loading';
    });
    builder.addCase(modifyHotelAssociate.fulfilled, (state, action) => {
        // const m = action.payload as IHotelAssociate[];
        console.log('modifyHotelAssociate.fulfilled: ');  
        state.addEditLoading = 'succeeded';
        Store.addNotification({
            title: APP_NAME,
            message: MSG_USER_MODIFICATION,
            type: 'success',
            insert: 'top',
            container: 'top-center',
            animationIn: ['animate__animated', 'animate__fadeIn'],
            animationOut: ['animate__animated', 'animate__fadeOut'],
            dismiss: {
            duration: notification_shown_time_success,
            onScreen: true,
            pauseOnHover: true,
            },
        });
    });
    builder.addCase(modifyHotelAssociate.rejected, (state, { payload }: any) => {
        state.addEditLoading = 'error';
        // state.error = action.error.message;
        console.log('payload2: ',payload); 
        // Store.addNotification({
        //   title: APP_NAME,
        //   message: MSG_USER_MODIFICATION_FAILED,
        //   type: 'danger',
        //   insert: 'top',
        //   container: 'top-center',
        //   animationIn: ['animate__animated', 'animate__fadeIn'],
        //   animationOut: ['animate__animated', 'animate__fadeOut'],
        //   dismiss: {
        //     duration: notification_shown_time_success,
        //     onScreen: true,
        //     pauseOnHover: true,
        //   },
        // });
      });


    builder.addCase(statusUpdateHotelAssociate.pending, (state) => { 
        state.addEditLoading = 'loading';
    });
    builder.addCase(statusUpdateHotelAssociate.fulfilled, (state, action) => {
        // const m = action.payload as IHotelAssociate[];
        console.log('statusUpdateHotelAssociate.fulfilled: ');  
        state.addEditLoading = 'statusUpdated';
        Store.addNotification({
            title: APP_NAME,
            message: MSG_USER_STATUS_UPDATE,
            type: 'success',
            insert: 'top',
            container: 'top-center',
            animationIn: ['animate__animated', 'animate__fadeIn'],
            animationOut: ['animate__animated', 'animate__fadeOut'],
            dismiss: {
            duration: notification_shown_time_success,
            onScreen: true,
            pauseOnHover: true,
            },
        });
    });
    builder.addCase(statusUpdateHotelAssociate.rejected, (state, { payload }: any) => {
        state.addEditLoading = 'statusUpdateFailed';
        // state.error = action.error.message;
        Store.addNotification({
          title: APP_NAME,
          message: MSG_USER_STATUS_UPDATE_FAILED,
          type: 'danger',
          insert: 'top',
          container: 'top-center',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: notification_shown_time_success,
            onScreen: true,
            pauseOnHover: true,
          },
        });
      });


      builder.addCase(resetUserPassword.pending, (state) => { 
        state.addEditLoading = 'loading';
    });
    builder.addCase(resetUserPassword.fulfilled, (state, action) => {
        // const m = action.payload as IHotelAssociate[];
        console.log('resetUserPassword.fulfilled: ');  
        state.addEditLoading = 'statusUpdated';
        Store.addNotification({
            title: APP_NAME,
            message: action.payload.message == 'user_does_not_exist' ? MSG_RESET_PASSWORD_USER_NOT_EXISTS :  MSG_RESET_PASSWORD_EMAIL_SENT, 
            type: action.payload.message == 'user_does_not_exist' ? 'danger' : 'success', 
            insert: 'top',
            container: 'top-center',
            animationIn: ['animate__animated', 'animate__fadeIn'],
            animationOut: ['animate__animated', 'animate__fadeOut'],
            dismiss: {
            duration: notification_shown_time_success,
            onScreen: true,
            pauseOnHover: true,
            },
        });
    });
    builder.addCase(resetUserPassword.rejected, (state, { payload }: any) => {
        state.addEditLoading = 'statusUpdateFailed';
        // state.error = action.error.message;
        Store.addNotification({
          title: APP_NAME,
          message: MSG_RESET_PASSWORD_EMAIL_FAILED,
          type: 'danger',
          insert: 'top',
          container: 'top-center',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: notification_shown_time_success,
            onScreen: true,
            pauseOnHover: true,
          },
        });
      });

  },
});

// Action creators are generated for each case reducer function
export const { setDataLoading } = hotelAssociatesAddEditSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectHotelAssociatesAddEditSlice = (state: RootState) => state.hotelAssociatesAddEditData;

export const hotelAssociatesAddEditReducer = hotelAssociatesAddEditSlice.reducer;
